module.exports = __webpack_public_path__ + "img/my-driving-school.02283770.png";